import { Component } from '@angular/core';
import { TranslationService } from '@proximus/ng-common';
import { IBackButtonOptions } from '@proximus/ng-common-components';

@Component({
  selector: 'mprd-back-link',
  templateUrl: './back-link.component.html',
})
export class BackLinkComponent {
  linkBackButtonOptions: IBackButtonOptions = {
    label: this.translationService.getTranslatedValueFor(
      'products.backbutton.label',
    ),
    buttonType: 'leftArrowPlainText',
    defaultRouterUrl: '/overview',
    isShownInWebview:
      this.translationService.getTranslatedValueFor(
        'products.backbutton.isShownInWebview',
      ) === 'true',
    pxPlusCloseWebViewDeeplink:
      this.translationService.getTranslatedValueFor(
        'products.backbutton.pxPlusCloseWebViewDeeplink',
      ) || 'myproximus://closeWebview',
    scarletCloseWebViewDeeplink:
      this.translationService.getTranslatedValueFor(
        'products.backbutton.scarletCloseWebViewDeeplink',
      ) || 'millennials://webtool/close',
    myPxsAppCloseWebViewDeeplink:
      this.translationService.getTranslatedValueFor(
        'products.backbutton.myPxsAppCloseWebViewDeeplink',
      ) || 'myproximus://closeWebview',
    isShownInWeb:
      this.translationService.getTranslatedValueFor(
        'products.backbutton.isShownInWeb',
      ) === 'true',
    shouldGoBackToDefaultRouterUrl: false,
    forceDisplayOfBackButton: false,
    hideOnEmptyHistory: true,
  };
  constructor(private translationService: TranslationService) {
  }
}
